import { AddIcon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";

const NewGoalRow = ({ onClick }) => (
  <Button
    border="1px dashed"
    borderColor="#3A4560"
    borderRadius="xl"
    color="gray.300"
    fontSize="lg"
    fontWeight="normal"
    h="72px"
    justifyContent="flex-start"
    leftIcon={<AddIcon boxSize="3.5" color="gray.500" />}
    onClick={onClick}
    px="6"
    variant="ghost"
    w="100%"
    _hover={{ bg: "#1A2138" }}
  >
    New goal
  </Button>
);

export default NewGoalRow;
